<div class="content-wrapper">
  <div class="row">
    <div class="col-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <div class="flex" style="display: flex;justify-content: space-between;">
            <div class="top-left">
              <h4 class="card-title"> New Manpower Request</h4>
              <h5> Requesters Details</h5>
            </div>
          </div>

          <br>
          <form class="forms-sample" #ngNewManPowerForm="ngForm" name="form"
             (ngSubmit)="ngNewManPowerForm.form.valid && onSubmit()">    
         
            <div style="background: #ECECEC;padding:30px;">
              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <label for="description">Requester Name<span> *</span></label>
                    <input type="text" class="form-control" id="requesterName"  
                      [(ngModel)]="requesterName" 
                      (ngModelChange)="saveToCache()"
                      required 
                      placeholder="e.g Mike Adenuga " 
                      name="requesterName" 
                      #requestername="ngModel">
                    <div class="alert alert-danger" role="alert"
                      *ngIf="ngNewManPowerForm.submitted && requestername.errors">
                      Requester Name is required!
                    </div>
                  </div>
                </div>
    
                <!-- Designation -->
                <div class="col">
                  <div class="form-group">
                    <label for="exampleInputCity1">Requester Designation<span> *</span></label>
                    <input type="text" class="form-control" id="designation" 
                      placeholder="ex: Designation" 
                      [(ngModel)]="designation"
                      (ngModelChange)="saveToCache()"
                      #Designation="ngModel" 
                      name="designation" 
                      required>
                    <div class="alert alert-danger" role="alert"
                      *ngIf="ngNewManPowerForm.submitted && Designation.errors">
                      Designation is required!
                    </div>
                  </div>
                </div>

                <!-- Function  -->
                <div class="col">
                  <div class="form-group">
                    <label for="selectedfunction">Requester Function <span> *</span></label>
                    <select class="form-control" required 
                      [(ngModel)]="selectedDepartmentId" 
                      name="selectedDepartmentId" 
                      #function="ngModel"
                      id="selectedDepartmentId"  
                      (ngModelChange)="onChangeFunction($event)">
                      <option value="">-- Select Function --</option>
                      <option [value]="department.name" *ngFor="let department of Departments">
                        {{department.name}}
                      </option>
                    </select>
                    <div class="alert alert-danger" role="alert"
                      *ngIf="ngNewManPowerForm.submitted && function.errors">
                      Function is required!
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="row">
                <!-- Unit  -->
                <div class="col">
                  <div class="form-group">
                    <label for="selectedfunction">Requester Unit <span> *</span></label>
                    <ng-select required 
                      [(ngModel)]="selectedFunctionId"  
                      (ngModelChange)="saveToCache()"
                      id="selectedFunctionId" 
                      name="selectedFunctionId" 
                      #unit="ngModel">
                      <ng-option *ngFor="let function of Functions" [value]="function.name">
                        {{function.name}}
                      </ng-option>
                    </ng-select>
                    <div class="alert alert-danger" role="alert"
                      *ngIf="ngNewManPowerForm.submitted && unit.errors">
                      Unit is required!
                    </div>
                  </div>
                </div>
                
                <!-- Request Date  -->
                <div class="col">
                  <div class="form-group">
                    <label for="exampleInputCity1">Request Date <span> *</span></label>
                    <input type="date" class="form-control" id="requestDate" 
                      placeholder="" 
                      name="requestDate" 
                      required
                      [(ngModel)]="requestDate" 
                      (ngModelChange)="saveToCache()"
                      #RequestsDate="ngModel">
                    <div class="alert alert-danger" role="alert"
                      *ngIf="ngNewManPowerForm.submitted && RequestsDate.errors">
                      Request Date is required!
                    </div>
                  </div>
                </div>
              </div>
            </div>
           
            <br>
            <h5>Details Of Required Manpower</h5>
            <br>

            <div style="background: #ECECEC;padding:30px;">
              <div class="row">
                <!-- Job Title -->
                <div class="col">
                  <div class="form-group">
                    <label for="description">Job Title<span> *</span></label>
                    <input type="text" class="form-control" id="jobTitle" 
                      placeholder="Job Title" 
                      name="jobTitle" 
                      [(ngModel)]="jobTitle"  
                      (ngModelChange)="saveToCache()"
                      #jobtitle="ngModel"
                      required>
                    <div class="alert alert-danger" role="alert"
                      *ngIf="ngNewManPowerForm.submitted && jobtitle.errors">
                      Job Title is required!
                    </div>
                  </div>
                </div>

                <!-- N+1 Designation  -->
                <div class="col">
                  <div class="form-group">
                    <label for="description">N + 1 Designation<span> *</span></label>
                    <input type="text" class="form-control" id="nPlusOneDsignation"  
                      [(ngModel)]="nPlusOneDsignation" 
                      (ngModelChange)="saveToCache()"
                      required
                      placeholder=" N + 1 Designation" 
                      name="nPlusOneDsignation" 
                      #nplusonedesignation="ngModel">
                    <div class="alert alert-danger" role="alert"
                      *ngIf="ngNewManPowerForm.submitted && nplusonedesignation.errors">
                      N + 1 Designation is required!
                    </div>
                  </div>
                </div>

                <div class="col">
                  <div class="form-group">
                    <label for="costCenter">Band<span> *</span></label>
                    <ng-select required 
                      [(ngModel)]="Band"  
                      (ngModelChange)="saveToCache()"
                      id="band" 
                      name="band" 
                      #bandss="ngModel">
                      <ng-option *ngFor="let b of band" [value]="b.name">
                        {{b.name}}
                      </ng-option>
                    </ng-select>
                    <div class="alert alert-danger" role="alert"
                      *ngIf="ngNewManPowerForm.submitted && bandss.errors">
                      Band is required!
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="row">
                <!-- Cost Center  -->
                <div class="col">
                  <div class="form-group">
                    <label for="costCenter">Cost Center<span> *</span></label>
                    <ng-select required 
                      [(ngModel)]="selectedCostCenterId" 
                      (ngModelChange)="saveToCache()"
                      id="selectedCostCenterId" 
                      name="selectedCostCenterId" 
                      #costcenter="ngModel">
                      <ng-option *ngFor="let costCenter of CostCenters" [value]="costCenter.name">
                        {{costCenter.code}} - {{costCenter.name}}
                      </ng-option>
                    </ng-select>
                    <div class="alert alert-danger" role="alert"
                      *ngIf="ngNewManPowerForm.submitted && costcenter.errors">
                      Cost Center is required!
                    </div>
                  </div>
                </div>

                <!-- Location  -->
                <div class="col">
                  <div class="form-group">
                    <label for="selectedLocation">Location<span> *</span></label>
                    <select class="form-control" required 
                      [(ngModel)]="selectedLocationId" 
                      (ngModelChange)="saveToCache()"
                      name="selectedLocationId"  
                      #location="ngModel"
                      id="selectedLocationId">
                      <option value="">-- Select Location --</option>
                      <option [value]="location.name" *ngFor="let location of Locations">
                        {{location.name}}
                      </option>
                    </select>
                    <div class="alert alert-danger" role="alert"
                      *ngIf="ngNewManPowerForm.submitted && location.errors">
                      Location is required!
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <!-- Date Vacancy Occured  -->
                <div class="col">
                  <div class="form-group">
                    <label for="exampleInputCity1">Date Vacancy Occured<span> *</span></label>
                    <input type="date"  class="form-control" id="dateVacancyOccured" 
                      placeholder="" 
                      name="dateVacancyOccured"
                      [(ngModel)]="dateVacancyOccured" 
                      (ngModelChange)="saveToCache()"
                      #datevacancyoccured="ngModel" 
                      required>
                    <div class="alert alert-danger" role="alert"
                      *ngIf="ngNewManPowerForm.submitted && datevacancyoccured.errors">
                      Date Vacancy Occured is required!
                    </div>
                  </div>
                </div>

                <!-- Required Number  -->
                <div class="col">
                  <div class="form-group">
                    <label for="description">Required Number<span> *</span></label>
                    <input type="number"  class="form-control" id="requiredNumber" 
                      [(ngModel)]="requiredNumber"
                      (ngModelChange)="saveToCache()"
                      placeholder="Required Number " 
                      name="requiredNumber"
                      #requirednumber="ngModel" 
                      required>
                    <div class="alert alert-danger" role="alert"
                      *ngIf="ngNewManPowerForm.submitted && requirednumber.errors">
                      Required Number is required!
                    </div>
                  </div>
                </div>
              </div>
              
              <br>
              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <label for="TypeOfVacancy">Type Of Vacancy<span> *</span></label>
                    <ng-select required 
                      [(ngModel)]="typeOfVacancy" 
                      (ngModelChange)="saveToCache()"
                      id="typeOfVacancy" 
                      name="typeOfVacancy" 
                      #typeofvacancys="ngModel">
                      <ng-option *ngFor="let a of typeofvacancy" [value]="a.vacancy">
                        {{a.vacancy}}
                      </ng-option>
                    </ng-select>
                    <div class="alert alert-danger" role="alert"
                      *ngIf="ngNewManPowerForm.submitted && typeofvacancys.errors">
                      Type Of Vacancy is required!
                    </div>
                  </div>
                </div>
             
                <div class="col">
                  <div class="form-group">
                    <label for="costCenter">Reason For Vacancy<span> *</span></label>
                    <ng-select required 
                      [(ngModel)]="reasonForVacancy" 
                      (ngModelChange)="saveToCache()"
                      id="reasonforvacancy" 
                      name="reasonforvacancy" 
                      #reasonforvacancy="ngModel">
                      <ng-option *ngFor="let a of Reasonforvacancy"  [value]="a.reasonforvacancy">
                        {{a.reasonforvacancy}}
                      </ng-option>
                    </ng-select>
                    <div class="alert alert-danger" role="alert"
                      *ngIf="ngNewManPowerForm.submitted && reasonforvacancy.errors">
                      Reason For Vacancy is required!
                    </div>
                  </div>
                </div>
              </div>
              
              <br>
              <div class="row">
                <!-- Other Specify  -->
                <div class="col">
                  <div class="form-group">
                    <label for="description">Other (Specify)</label>
                    <input type="text" class="form-control" id="other" 
                      [(ngModel)]="otherReasonForVacancy"
                      (ngModelChange)="saveToCache()"
                      placeholder="OTHER (Specify) " 
                      name="other">
                  </div>
                </div>
                
                <div class="col">
                  <div class="form-group">
                    <label for="document" class="control-label col-md-10">
                      Select Document (Job Description) PDF Only <span> *</span>
                    </label>
                    <div class="col-md-10">
                      <input type="file" 
                        (change)="onFileChange($event)" 
                        placeholder="Upload file" 
                        [(ngModel)]="file" 
                        #document="ngModel"
                        accept=".pdf,.doc" 
                        #fileInput 
                        name="fileInput" 
                        style="padding-top:2px;"
                        class="form-control">
                    </div>
                    <div class="alert alert-danger" role="alert"
                      *ngIf="ngNewManPowerForm.submitted && document.errors">
                      Document is required!
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <br>
            <h5> Mode Of Recruitment</h5>
            <br>
          
            <div style="background: #ECECEC;padding:30px;">
              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <label for="exampleSelectDesignation">Mode Of Recruitment<span> *</span></label>
                    <select class="form-control" required 
                      [(ngModel)]="modeOfRecruitment" 
                      name="modeofrecruitment" 
                      placeholder="Select Mode Of Recruitment"
                      id="modeofrecruitment"  
                      #modeofrecruitment="ngModel"   
                      (ngModelChange)="onChangeDesignation($event)">
                      <option [value]="d.modeofrecruitments" *ngFor="let d of ModeOfrecRuitment">
                        {{d.modeofrecruitments}}
                      </option>
                    </select>
                    <div class="alert alert-danger" role="alert"
                      *ngIf="ngNewManPowerForm.submitted && modeofrecruitment.errors">
                      Mode of Recruitment is required!
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="row" *ngIf="isreasonForVacancyVisible">
                <label class="col-sm-3 col-form-label"> Internal Movement </label> 
                <div class="col-sm-3">
                  <div class="form-check">
                    <label class="form-check-inline"> 
                      <input type="checkbox" class="form-check-input"   
                        [(ngModel)]="FTERequirements.InternalMovement" 
                        (ngModelChange)="saveToCache()"
                        name="modeofrecruitmentfte" 
                        id="internalmovement">
                    </label>
                  </div>   
                </div>
                
                <label class="col-sm-3 col-form-label"> External(New Staff) </label> 
                <div class="col-sm-1">
                  <div class="form-check">
                    <label class="form-check-inline"> 
                      <input type="checkbox" class="form-check-input" 
                        [(ngModel)]="FTERequirements.ExternalNewStaff" 
                        (ngModelChange)="saveToCache()"
                        name="modeofrecruitmentfte" 
                        id="externalnewstaff">
                    </label>
                  </div>   
                </div>
              </div>
               
              <!-- Duration of contract  -->
              <div class="row"  *ngIf="isreasonForVacancy">
                <div class="col">
                  <div class="form-group">   
                    <label for="description">Contract Duration (Month)</label>
                    <input type="number" class="form-control" id="durationofcontract"
                      placeholder="Duration Of Contract " 
                      name="durationofcontract" 
                      [(ngModel)]="durationofcontract"
                      (ngModelChange)="saveToCache()">
                  </div>
                </div>

                <!-- Estimated Annual Cost  -->
                <div class="col">
                  <div class="form-group">
                    <label for="description">Estimated Annual Cost</label>
                    <input type="number" class="form-control" id="estimatedcost"
                      placeholder="Estimated Annual Cost" 
                      name="estimatedcost" 
                      [(ngModel)]="estimatedcost"
                      (ngModelChange)="saveToCache()">
                  </div>
                </div>
              </div>
            </div>
            
            <div class="col">
              <div class="form-group">
                <label for="exampleTextarea1">Justification For Vacancy<span> *</span></label>
                <textarea class="form-control" id="justification" rows="4" 
                  name="justification" 
                  [(ngModel)]="justification" 
                  (ngModelChange)="saveToCache()"
                  #Justification="ngModel"
                  required></textarea>
                <div class="alert alert-danger" role="alert"
                  *ngIf="ngNewManPowerForm.submitted && Justification.errors">
                  Justification is required!
                </div>
              </div>
            </div>

            <br>
            <h5>Role Requirements</h5>
            <br>

            <div style="background: #ECECEC;padding:30px;">
              <div class="row">
                <!-- Educational Qualification  -->
                <div class="col">
                  <div class="form-group">
                    <label for="justification">Educational Qualification<span> *</span></label>
                    <textarea class="form-control" id="educationalqualification" rows="4" 
                      name="educationalqualification" 
                      required 
                      [(ngModel)]="educationalqualification" 
                      (ngModelChange)="saveToCache()"
                      #educationqualification="ngModel"></textarea>
                    <div class="alert alert-danger" role="alert"
                      *ngIf="ngNewManPowerForm.submitted && educationqualification.errors">
                      Qualification is required!
                    </div>
                  </div>
                </div>
    
                <!-- Skills Required  -->
                <div class="col">
                  <div class="form-group">
                    <label for="justification">Skills Required<span> *</span></label>
                    <textarea class="form-control" id="skillsrequired" rows="4" 
                      #skills="ngModel" 
                      name="skillsrequired" 
                      [(ngModel)]="skillsrequired"
                      (ngModelChange)="saveToCache()"
                      required></textarea>
                    <div class="alert alert-danger" role="alert"
                      *ngIf="ngNewManPowerForm.submitted && skills.errors">
                      Skills is required!
                    </div>
                  </div>
                </div>

                <!-- Experience  -->
                <div class="col">
                  <div class="form-group">
                    <label for="exampleTextarea1">Experience<span> *</span></label>
                    <textarea class="form-control" id="experience" rows="4" 
                      name="experience" 
                      [(ngModel)]="experience" 
                      (ngModelChange)="saveToCache()"
                      #Experience="ngModel"
                      required></textarea>
                    <div class="alert alert-danger" role="alert"
                      *ngIf="ngNewManPowerForm.submitted && Experience.errors">
                      Experience is required!
                    </div>
                  </div>
                </div>
              </div>

              <label> Systems Requirements</label>
              <div class="row">
                <label class="col-sm-0 col-form-label"> BCMIX </label>
                <div class="col-sm-1">
                  <div class="form-check">
                    <label class="form-check-inline"> 
                      <input type="checkbox" class="form-check-input" 
                        [(ngModel)]="systemRequirements.BCMIX" 
                        (ngModelChange)="saveToCache()"
                        name="systemrequirements" 
                        id="bcmix">
                    </label>
                  </div>   
                </div>

                <label class="col-sm-0 col-form-label"> LABMIX </label>
                <div class="col-sm-1">
                  <div class="form-check">
                    <label class="form-check-inline"> 
                      <input type="checkbox" class="form-check-input" 
                        [(ngModel)]="systemRequirements.LABMIX" 
                        (ngModelChange)="saveToCache()"
                        name="systemrequirements" 
                        id="labmix">
                    </label>
                  </div>   
                </div>

                <label class="col-sm-0 col-form-label"> HOLDIM </label>
                <div class="col-sm-1">
                  <div class="form-check">
                    <label class="form-check-inline"> 
                      <input type="checkbox" class="form-check-input" 
                        [(ngModel)]="systemRequirements.HOLDIM" 
                        (ngModelChange)="saveToCache()"
                        name="systemrequirements" 
                        id="holdim">
                    </label>
                  </div>   
                </div>

                <label class="col-sm-0 col-form-label"> SALESFORCE </label>
                <div class="col-sm-1">
                  <div class="form-check">
                    <label class="form-check-inline"> 
                      <input type="checkbox" class="form-check-input" 
                        [(ngModel)]="systemRequirements.SALESFORCE" 
                        (ngModelChange)="saveToCache()"
                        name="systemrequirements" 
                        id="salesforce">
                    </label>
                  </div>   
                </div>

                <label class="col-sm-0 col-form-label"> SAP </label>
                <div class="col-sm-1">
                  <div class="form-check">
                    <label class="form-check-inline"> 
                      <input type="checkbox" class="form-check-input" 
                        [(ngModel)]="systemRequirements.SAP" 
                        (ngModelChange)="saveToCache()"
                        name="systemrequirements" 
                        id="sap">
                    </label>
                  </div>   
                </div>
              </div>
                 
              <div class="row">
                <!-- Other Requirements  -->
                <div class="col">
                  <div class="form-group">
                    <label for="description">Other Requirement</label>
                    <input type="text" class="form-control" id="otherrequirements" 
                      [(ngModel)]="otherRequirements"
                      (ngModelChange)="saveToCache()"
                      placeholder="otherrequirements " 
                      name="otherrequirements">
                  </div>
                </div>
              </div>
            </div>
  
            <div class="class=col-lg-6 grid-margin">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Approvals</h4>

                  <div style="background: #ECECEC;padding:30px;">
                    <table class="table table-bordered ">
                      <tbody>
                        <tr>
                          <td>1</td>
                          <td>Unit Head <span> *</span></td>
                          <td>
                            <ng-select required 
                              [(ngModel)]="selectedManagerId"  
                              (ngModelChange)="saveToCache()"
                              id="selectedManagerId"  
                              name="selectedManagerId">
                              <ng-option *ngFor="let manager of Managers" [value]="manager.email">
                                {{manager.firstName}} - {{manager.email}}
                              </ng-option>
                            </ng-select>
                            <div class="alert alert-danger" 
                              *ngIf="ngNewManPowerForm.submitted && selectedManagerId.length==0">
                              <sup>*</sup>Please provide Unit Head to approve
                            </div>
                          </td>
                        </tr>
                        
                        <tr *ngIf="isShowPlantManager">
                          <td>2</td>
                          <td>Plant Manager <span> *</span></td>
                          <td>
                            <ng-select required 
                              [(ngModel)]="selectedPlantManagerId"  
                              (ngModelChange)="saveToCache()"
                              id="selectedPlantManagerId" 
                              name="selectedPlantManagerId">
                              <ng-option *ngFor="let plant of PlantManagers" [value]="plant.email">
                                {{plant.firstName}} - {{plant.email}}
                              </ng-option>
                            </ng-select>
                            <div class="alert alert-danger" 
                              *ngIf="ngNewManPowerForm.submitted && selectedfunctionalDirectorId.length==0">
                              <sup>*</sup>Please provide Plant Manager to approve
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td>{{funcdirectorCount}}</td>
                          <td>Functional Director <span> *</span></td>
                          <td>
                            <ng-select required 
                              [(ngModel)]="selectedfunctionalDirectorId"  
                              (ngModelChange)="saveToCache()"
                              id="selectedfunctionalDirectorId" 
                              name="selectedfunctionalDirectorId">
                              <ng-option *ngFor="let director of FunctionalDirectors" 
                                [value]="director.email">
                                {{director.firstName}} - {{director.email}}
                              </ng-option>
                            </ng-select>
                            <div class="alert alert-danger" 
                              *ngIf="ngNewManPowerForm.submitted && selectedfunctionalDirectorId.length==0">
                              <sup>*</sup>Please provide Functional Director to approve
                            </div>
                          </td>
                        </tr>
                        
                        <tr>
                          <td>{{hrbpCount}}</td>
                          <td>HRBP <span> *</span></td>
                          <td>
                            <ng-select required 
                              [(ngModel)]="selectedhrbpId"  
                              (ngModelChange)="saveToCache()"
                              id="selectedhrbpId" 
                              name="selectedhrbpId">
                              <ng-option *ngFor="let hrbp of HRBPS" [value]="hrbp.email">
                                {{hrbp.firstName}} - {{hrbp.email}}
                              </ng-option>
                            </ng-select>
                            <div class="alert alert-danger" 
                              *ngIf="ngNewManPowerForm.submitted && selectedhrbpId.length==0">
                              <sup>*</sup>Please provide HRBP to approve
                            </div>
                          </td>
                        </tr>
                      
                        <tr>
                          <td>{{hrCount}}</td>
                          <td>O & HR Director <span> *</span></td>
                          <td>{{ohrdToApprove}}</td>
                        </tr>

                        <tr>
                          <td>{{ceoCount}}</td>
                          <td>CCEO <span> *</span></td>
                          <td>{{ceoToApprove}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <hr>
            <div class="text-left">
              <button type="submit" [disabled]="clicked"  class="btn btn-primary mr-2 ">Submit</button>
              <button class="btn btn-light">Cancel</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>